// extracted by mini-css-extract-plugin
module.exports = {"Trigger":"BasicLayout--Trigger--1CMMHtJ","navContent":"BasicLayout--navContent--2GKHWh3","TopMenu":"BasicLayout--TopMenu--Gz5VTHX"};